import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {AuthService} from "../../features/components/auth/auth.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
      private readonly authService: AuthService,
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
      const token: string | null = this.authService.getToken();
    request = request.clone({
      setHeaders: {
        hasParam: "admin",
      },
    });
      if (token) {
          request = request.clone({
              setHeaders: {
                  Authorization: `Bearer ${token}`,
              },
          });
      }
    return next.handle(request);
  }
}
